import React from "react";
import { Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Insight } from "@stratify/shared";
import { useDispatch } from "react-redux";
import { trackEvent } from "../../analytics/store/analyticsSlice";

interface CopyAllInsightsButtonProps {
  insights: Insight[];
}

export const CopyAllInsightsButton: React.FC<CopyAllInsightsButtonProps> = ({
  insights,
}) => {
  const dispatch = useDispatch();
  const [buttonText, setButtonText] = React.useState("Copy All");

  const handleCopyAllClick = async () => {
    if (!insights.length) {
      return;
    }

    try {
      dispatch(
        trackEvent({
          name: "all_insights_copied",
          params: {
            document_id: insights[0].documentId,
          },
        })
      );
      const allInsightsText = insights
        .map((insight) => `${insight.description}`)
        .join("\n\n");
      await navigator.clipboard.writeText(allInsightsText);

      setButtonText("Copied!");
      setTimeout(() => {
        setButtonText("Copy All");
      }, 2000);
    } catch (err) {
      alert("Failed to copy insights to clipboard.");
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <Button
      variant="outlined"
      onClick={handleCopyAllClick}
      size="medium"
      color={buttonText === "Copied!" ? "success" : "primary"}
      startIcon={<ContentCopyIcon />}
    >
      {buttonText}
    </Button>
  );
};
